import { Box } from '@mui/material';
import React from 'react';

export default function BottomBar() {
  return <Box position="absolute" bottom="0" left="0" right="0" height={6} bgcolor="#8974FC"></Box>;
}
